import { getAllSettingRequest } from "../repositories/setting_repository";

export const SettingService = () => {
    const fetchAllSetting = async (setSettingList) => {
        try {
            const response = await getAllSettingRequest();
            if (response?.success) {
                setSettingList(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch setting links.")
        }
    };

    return {
        fetchAllSetting,
    };
};